import React from "react";
import { Link } from "react-router-dom";

export default function Forbidden() {
  return (
    <div className="min-h-[85vh] flex items-center justify-center bg-brand-sand-50 pt-[72px]">
      <div className="max-w-md mx-auto px-6 text-center flex flex-col items-center gap-6">
        <span className="text-brand-sand-500 font-display text-8xl font-bold">403</span>
        <h1 className="font-display text-3xl font-bold text-brand-green-900 leading-tight">
          Adgang nægtet
        </h1>
        <p className="text-brand-charcoal/70 text-sm leading-relaxed">
          Du har ikke tilladelse til at tilgå denne side eller ressource.
        </p>
        <div className="w-16 h-0.5 bg-brand-sand-500" />
        <Link
          to="/"
          className="px-6 py-3 bg-brand-green-900 hover:bg-brand-green-800 text-brand-sand-100 font-bold text-xs tracking-wide rounded-sm transition-all duration-300 hover:shadow-md cursor-pointer"
        >
          Gå til forsiden
        </Link>
      </div>
    </div>
  );
}
